import { useEffect, useState } from "react";

const breakpoints = {
  smallMobile: 460,
  mobile: 640,
  tablet: 768,
  bigTablet: 1024,
  smallDesktop: 1439,
  desktop: 1440,
};

const useWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isSmallMobile: width <= breakpoints.smallMobile,
    isMobile: width <= breakpoints.mobile,
    isTablet: width > breakpoints.mobile && width <= breakpoints.tablet,
    isBigTablet: width > breakpoints.tablet && width <= breakpoints.bigTablet,
    isSmallDesktop:
      width > breakpoints.bigTablet && width <= breakpoints.smallDesktop,
    isDesktop: width > breakpoints.smallDesktop,
  };
};

export default useWidth;
